export const EMPTY_METRIC_DATA: '-' = '-' as const;

export const TOOLTIP_EMPTY_METRIC_DATA =
  'Test experiment is live and needs 24 hours to gather data';
